import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-cancel-note',
  templateUrl: './modal-cancel-note.component.html',
  styleUrls: ['./modal-cancel-note.component.scss']
})
export class ModalCancelNoteComponent implements OnInit {

  modalData: any;
  cancelForm: FormGroup;
  isRead: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalCancelNoteComponent>,
    private fb: FormBuilder,
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    this.cancelForm = this.fb.group({
      note: [this.modalData.remark, Validators.required],
    });
  }

  confirm(form) {
    const response = {
      status: true,
      value: form.note
    }
    this.dialogRef.close(response);
  }

  closeModal() {
    const response = {
      status: false
    }
    this.dialogRef.close(response);
  }

  isEdit() {
    this.isRead = !this.isRead;
  }

}
